<template>
    <div class="container forgotpassword">
        <div class="container">
            <h5 class="title is-5">Glemt passord?</h5>
            <p>Angi epostadressen du er registrert med i feltet nedenfor så vil vi sende deg et nytt passord på din epost dersom vi finner epostadressen i medlemsregisteret vårt.</p></div>
        <div class="container">
            <div class="columns">
                <div class="column is-two-thirds">
                    <div class="box">
                        <form @submit.prevent="commitForm">
                            <b-field horizontal label="Epostadresse">
                                <b-input name="email" type="email" v-model="email"></b-input>
                            </b-field>
                            <b-field horizontal :label="`Hva er ${random1} + ${random2}?`">
                                <b-input name="email" required v-model="answer"></b-input>
                            </b-field>

                            <b-field horizontal>
                                <p class="control">
                                    <button type="submit" class="button is-primary">
                                    Send nytt passord
                                    </button>
                                </p>
                            </b-field>
                        </form>

                    </div>
                </div>
                <div class="column">
                    <b-message type="is-info" has-icon>
                        <h6 class="title is-6">Savner du tilgang?</h6>
                        <p>Du har ikke mulighet til å registrere bruker selv. Tilgang til rapportløsningen styres av IGive. Dersom du ønsker tilgang eller har andre problemer med å logge på, kontakt oss på <a href="mailto:support@igive.no">support@igive.no</a></p>
                    </b-message>
                </div>
            </div>
        </div>
        
        
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data () {
        return {
            email: '',
            random1: Math.floor(Math.random() * 10),
            random2: Math.floor(Math.random() * 10),
            answer: ''
        }
    },
    methods: {
        ...mapActions('auth', ['forgotPassword']),
        async commitForm () {
            try {
                const answerInt = parseInt(this.answer)
                if (answerInt !== this.random1 + this.random2)
                    throw "Svaret på regnestykket er ikke riktig"

                await this.forgotPassword(this.email)
                this.$buefy.toast.open({
                    message: 'Forespørsel mottatt. Dersom bruker er registrert på denne epostadressen vil du motta instruksjoner for pålogging innen et par minutter',
                    type: 'is-success',
                    position: 'is-bottom',
                    duration: 5000

                })
            } catch (error) {
                this.$buefy.toast.open({
                    message: `En feil oppstod under innsending av forespørsel: ${error}. Vennligst prøv igjen senere eller ta kontakt på epost: support@igive.no`,
                    type: 'is-danger',
                    position: 'is-bottom',
                    duration: 5000
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
div.forgotpassword {
    margin-top:32px;
}
div.container {
    margin-bottom: 32px;
}
</style>
